import { type TScreenName } from '../types/screenNameTypes'

let currentScreen: TScreenName = 'not_supported_screen'

// web-vitals reports a soft-navigation metric for a URL the visitor may have already left, so the
// screen of every visited path is kept: `navigationURL` resolves against this, not the live screen.
const screensByPath = new Map<string, TScreenName>()

export const setCurrentScreen = (screen: TScreenName) => {
    currentScreen = screen

    if (typeof window !== 'undefined') {
        screensByPath.set(window.location.pathname, screen)
    }
}

export const getCurrentScreen = (): TScreenName => currentScreen

export const hasScreenForPath = (pathname: string): boolean => screensByPath.has(pathname)

export const getScreenForPath = (pathname: string): TScreenName =>
    screensByPath.get(pathname) ?? currentScreen

export const getVisitedScreenForPath = (pathname: string): TScreenName =>
    screensByPath.get(pathname) ?? 'not_supported_screen'
